import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const MIN_COLUMN_WIDTH = 60;

export const useAdminTableStyles = makeStyles({
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },

  table: {
    width: "100%",
  },

  tableHeader: {
    backgroundColor: designTokens.neutral[50],
    ...shorthands.borderBottom("1px", "solid", designTokens.neutral[200]),
  },

  headerCell: {
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[500],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    fontFamily: designTokens.fontFamily,
    whiteSpace: "nowrap",
    padding: `${designTokens.spacing[1]} 0 ${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    boxSizing: "border-box",
  },

  headerCellResizable: {
    paddingRight: "0 !important",
    boxSizing: "border-box",
    overflow: "hidden",
  },

  headerCellContent: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },

  resizeHandle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "5px",
    alignSelf: "stretch",
    cursor: "col-resize",
    zIndex: 1,
    marginTop: "1.5px",
    marginBottom: "1.5px",
    "::after": {
      content: '""',
      width: "1px",
      height: "100%",
      backgroundColor: designTokens.neutral[300],
      transition: `background-color ${designTokens.transition.fast}`,
    },
    ":hover::after": {
      backgroundColor: designTokens.neutral[500],
      width: "2px",
    },
  },

  headerCellSortable: {
    cursor: "pointer",
    userSelect: "none",
  },

  tableRow: {
    ...shorthands.borderBottom("1px", "solid", designTokens.neutral[200]),
    transition: `background-color ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: designTokens.primary[100],
    },
    textWrap: "auto",
  },

  tableRowHighlighted: {
    backgroundColor: designTokens.primary[100],
  },

  tableCell: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[600],
    fontFamily: designTokens.fontFamily,
    overflow: "hidden",
    boxSizing: "border-box",
    minWidth: 0,
    padding: `0 0 0 ${designTokens.spacing[3]}`,
  },

  headerCellInner: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    overflow: "hidden",
    maxWidth: "100%",
    minWidth: 0,
  },

  headerCellLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },

  firstColumnCell: {
    paddingLeft: designTokens.spacing[6],
  },

  emptyStateCell: {
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[6]}`,
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.sm,
    textAlign: "center",
  },
});

export const useAdminSelectionColumnStyles = makeStyles({
  selectionColumn: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: "44px",
    width: "44px",
    minWidth: "44px",
    overflow: "visible",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.padding("0"),
  },
});

export const useAdminColumnStyles = makeStyles({
  narrow: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: "80px",
    overflow: "hidden",
  },
  medium: {
    flexGrow: 3,
    flexBasis: 0,
    minWidth: "100px",
    overflow: "hidden",
  },
  normal: {
    flexGrow: 5,
    flexBasis: 0,
    minWidth: "120px",
    overflow: "hidden",
  },
  wide: {
    flexGrow: 8,
    flexBasis: 0,
    minWidth: "150px",
    overflow: "hidden",
  },
  actions: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: "var(--actions-width, 120px)",
    width: "var(--actions-width, 120px)",
    minWidth: "var(--actions-width, 120px)",
    overflow: "visible",
    boxSizing: "border-box",
  },
});
